interface LoadingSpinnerProps {
  message?: string;
}

export default function LoadingSpinner({ message }: LoadingSpinnerProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3">
      <div
        className="w-8 h-8 rounded-full border-4 border-blue-200 border-t-blue-500 animate-spin"
        role="status"
        aria-label={message ?? 'Loading'}
      />
      {message && (
        <p className="text-sm text-slate-500 font-medium">{message}</p>
      )}
    </div>
  );
}
